import { render, staticRenderFns } from "./vue-json-editor.vue?vue&type=template&id=9b72cb1a&scoped=true&"
import script from "./vue-json-editor.vue?vue&type=script&lang=js&"
export * from "./vue-json-editor.vue?vue&type=script&lang=js&"
import style0 from "./vue-json-editor.vue?vue&type=style&index=0&id=9b72cb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b72cb1a",
  null
  
)

export default component.exports